import { putMethodWithToken } from 'services/apiServices';
import url from 'services/urls.json';
import { ClearTokenRedirectLogin } from 'utils/general';

// Action Types
export const RESEND_INVITATION = 'RESEND_INVITATION';
export const RESEND_INVITATION_SUCCESS = 'RESEND_INVITATION_SUCCESS';
export const RESEND_INVITATION_FAILURE = 'RESEND_INVITATION_FAILURE';

// Action Creators
export const resendInvitation = () => ({
  type: RESEND_INVITATION,
});

export const resendInvitationSuccess = (data) => ({
  type: RESEND_INVITATION_SUCCESS,
  payload: data,
});

export const resendInvitationFailure = (error) => ({
  type: RESEND_INVITATION_FAILURE,
  payload: error,
});

// Thunk Function
export const resendInvitationCallAPI = (data, external = {}) => {
  return async (dispatch) => {
    dispatch(resendInvitation(data, external));
    try {
      const response = await putMethodWithToken(
        url.resendInvitation + data + '/',
        {}
      );
      if (response.status === 200 || response.status === 201) {
        dispatch(resendInvitationSuccess(response.data));

        if (external && external.redirect === true) {
          external.redirectNavigate(external.path);
        } else if (external && external.run === true) {
          external.handleFunction(response);
        } else if (external && external.step) {
          external.handleStep(external.step);
        }
      } else if (response.status === 401) {
        ClearTokenRedirectLogin(external?.navigate);
      } else {
        dispatch(resendInvitationFailure('Error'));
        if (external && external.toast) {
          external.handleToastError(response);
        }
      }
    } catch (error) {
      dispatch(resendInvitationFailure(error.message));
    }
  };
};
